import React, { useEffect } from 'react';
import { recoverMessageAddress } from 'viem';
import { useAccount, useSignMessage } from 'wagmi';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserInfo, fetchVerifySignature } from '../redux/slices/UserSlice';
import { Modal } from 'react-bootstrap'
import verifyImg from '../images/tick-mark.png';

export default function VerifyModal() {
    const { address } = useAccount();
    const { data: signMessageData, signMessage, variables } = useSignMessage()
    const dispatch = useDispatch();
    const theme = useSelector((state) => state.user.theme);


    useEffect(() => {
        ; (async () => {
            if (variables?.message && signMessageData) {
                const recoveredAddress = await recoverMessageAddress({
                    message: variables?.message,
                    signature: signMessageData,
                })

                dispatch(fetchVerifySignature({
                    address: recoveredAddress,
                    signature: signMessageData,
                })).then(() => {
                    dispatch(fetchUserInfo({
                        address
                    }))
                })
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signMessageData, variables?.message])

    return (
        <Modal
            show={true}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={`${theme}-scheme p-4`}
        >
            <Modal.Body >
                <div className='d-flex justify-content-between'>
                    <h3>Verify Login</h3>
                </div>
                <div className='text-center justify-content-center mb-3'>
                    <img src={verifyImg} alt='verify' className='verify-icon mb-4' /> <br/>
                    <button onClick={() => signMessage({ message: "BlockStar NFT Login Message" })} type='button' className="btn-main btn-wallet">
                        <i className="icon-wallet mr-md-2" /> <span>Verify Login</span>
                    </button >
                </div>

            </Modal.Body>

        </Modal>
    )
}
